import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=71618c83&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=71618c83&prod&lang=css&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=71618c83&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71618c83",
  null
  
)

export default component.exports